module.exports = __webpack_public_path__ + "img/periodico.e3eeb4d8.jpg";